import { AnimationMixer, Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import * as dat from "dat.gui";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";
import model from "../../../../../assets/models/employees/GLB_Male_employee_v3.glb";
import modelFemale from "../../../../../assets/models/employees/GLB_Female employee v3.glb";

export class CharacterToDress extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.mixer = null;
		this.mixerFemale = null;
		this.scale.set(2, 2, 2);
		this.position.set(-3.7, -2.9, -6.4);
		this.rotation.y = -7.8;
		this.observerListenners();
		// this.createGUI();
		// this.rotation.y = MathUtils.degToRad(90)
	}

	createGUI() {
		const gui = new dat.GUI();
		const positionFolder = gui.addFolder("Position"); // Carpeta para la posición

		positionFolder.add(this.position, "x", -10, 10).onChange((value) => {
			this.position.x = value;
		});

		positionFolder.add(this.position, "y", -10, 10).onChange((value) => {
			this.position.y = value;
		});
		positionFolder.add(this.position, "z", -10, 10).onChange((value) => {
			this.position.z = value;
		});
		positionFolder.add(this.rotation, "y", -10, 10).onChange((value) => {
			this.position.z = value;
		});
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			// prendas

			// default
			this.male_sandals_01 = gltf.scene.getObjectByName("male_sandals_01", true);
			this.male_shirt_01 = gltf.scene.getObjectByName("male_shirt_01", true);
			this.male_short_01 = gltf.scene.getObjectByName("male_short_01", true);

			this.male = gltf.scene.getObjectByName("MaleEmployee_hips", true);
			this.male_bermuda_shorts = gltf.scene.getObjectByName("male_bermuda_shorts", true);
			this.male_blue_shirt = gltf.scene.getObjectByName("male_blue_shirt", true);
			this.male_flip_flops = gltf.scene.getObjectByName("male_flip_flops", true);
			this.male_oxxo_shirt = gltf.scene.getObjectByName("male_oxxo_shirt", true);
			this.male_pants = gltf.scene.getObjectByName("male_pants", true);
			this.male_sandals = gltf.scene.getObjectByName("male_sandals", true);
			this.male_shirt = gltf.scene.getObjectByName("male_shirt", true);
			this.male_shoes = gltf.scene.getObjectByName("male_shoes", true);
			this.male_shorts = gltf.scene.getObjectByName("male_shorts", true);

			this.onSetClothesGenere(true);
			//
			const animations = gltf.animations;
			if (animations && animations.length) {
				this.mixer = new AnimationMixer(gltf.scene);
				this.mixer.clipAction(animations[0]).play(); // Reproducir la primera animación
			}
		});
		loader.load(modelFemale, (gltf) => {
			this.add(gltf.scene);
			this.female = gltf.scene.getObjectByName("FemaleEmployee_hips", true);
			// prendas
			this.female_pants_01 = gltf.scene.getObjectByName("female_pants_01", true);
			this.female_sandals_01 = gltf.scene.getObjectByName("female_sandals_01", true);
			this.female_top_01 = gltf.scene.getObjectByName("female_top_01", true);

			// defaultprendas

			this.female_oxxo_shirt = gltf.scene.getObjectByName("female_oxxo_shirt", true);

			this.female_oxxo_shirt = gltf.scene.getObjectByName("female_oxxo_shirt", true);
			this.female_shirt = gltf.scene.getObjectByName("female_shirt", true);
			this.female_top = gltf.scene.getObjectByName("female_top", true);

			this.female_pants = gltf.scene.getObjectByName("female_pants", true);
			this.female_short = gltf.scene.getObjectByName("female_short", true);
			this.female_skirt = gltf.scene.getObjectByName("female_skirt", true);

			this.female_shoes = gltf.scene.getObjectByName("female_shoes", true);
			this.female_heels = gltf.scene.getObjectByName("female_heels", true);
			this.female_sandals = gltf.scene.getObjectByName("female_sandals", true);
			this.female.visible = false;

			// this.onHiddenAllClothes();
			//
			const animations = gltf.animations;
			if (animations && animations.length) {
				this.mixerFemale = new AnimationMixer(gltf.scene);
				this.mixerFemale.clipAction(animations[0]).play(); // Reproducir la primera animación
			}
		});
	}

	onSetClothesGenere(genere) {
		if (genere) {
			this.upClothes = [
				{
					id: 1,
					clothe: this.male_shirt,
				},
				{
					id: 2,
					clothe: this.male_blue_shirt,
				},
				{
					id: 3,
					clothe: this.male_oxxo_shirt,
				},
				{
					id: 20,
					clothe: this.male_shirt_01,
				},
			];

			this.middleClothes = [
				{
					id: 4,
					clothe: this.male_bermuda_shorts,
				},
				{
					id: 5,
					clothe: this.male_pants,
				},
				{
					id: 6,
					clothe: this.male_shorts,
				},
				{
					id: 21,
					clothe: this.male_short_01,
				},
			];

			this.botoomClothes = [
				{
					id: 7,
					clothe: this.male_shoes,
				},
				{
					id: 8,
					clothe: this.male_flip_flops,
				},
				{
					id: 9,
					clothe: this.male_sandals,
				},
				{
					id: 22,
					clothe: this.male_sandals_01,
				},
			];
		} else {
			this.upClothes = [
				{
					id: 1,
					clothe: this.female_top,
				},
				{
					id: 2,
					clothe: this.female_shirt,
				},
				{
					id: 3,
					clothe: this.female_oxxo_shirt,
				},
				{
					id: 20,
					clothe: this.female_top_01,
				},
			];

			this.middleClothes = [
				{
					id: 4,
					clothe: this.female_short,
				},
				{
					id: 5,
					clothe: this.female_pants,
				},
				{
					id: 6,
					clothe: this.female_skirt,
				},
				{
					id: 21,
					clothe: this.female_pants_01,
				},
			];

			this.botoomClothes = [
				{
					id: 7,
					clothe: this.female_shoes,
				},
				{
					id: 8,
					clothe: this.female_heels,
				},
				{
					id: 9,
					clothe: this.female_sandals,
				},
				{
					id: 22,
					clothe: this.female_sandals_01,
				},
			];
		}
	}

	observerListenners() {
		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.upChangeClothe, (id) => {
			this.onShowClotheSelected(this.upClothes, id);
		});
		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.middleChangeClothe, (id) => {
			this.onShowClotheSelected(this.middleClothes, id);
		});
		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.botoomChangeClothe, (id) => {
			this.onShowClotheSelected(this.botoomClothes, id);
		});
		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.onHiddenAllClothes, () => {
			if (this.male_oxxo_shirt) {
				this.onHiddenAllClothes();
			}
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.visibleCharacterDress, () => {
			this.visible = true;
		});

		ObserverEmitter.on(EVENTS.subtopicOne.activityOne.changeGenere, (genere) => {
			if (genere) {
				this.male.visible = true;
				this.female.visible = false;
				this.onSetClothesGenere(true);
			} else {
				this.male.visible = false;
				this.female.visible = true;
				this.onSetClothesGenere(false);
			}
		});
	}

	onShowClotheSelected(clothesList, id) {
		clothesList.forEach((clothe) => {
			if (clothe.id === id) {
				clothe.clothe.visible = true;
			} else {
				clothe.clothe.visible = false;
			}
		});
	}

	onHiddenAllClothes() {
		if (this.male_oxxo_shirt) {
			this.male_oxxo_shirt.visible = false;
			this.male_blue_shirt.visible = false;
			this.male_shirt.visible = false;

			this.male_bermuda_shorts.visible = false;
			this.male_pants.visible = false;
			this.male_shorts.visible = false;

			this.male_shoes.visible = false;
			this.male_flip_flops.visible = false;
			this.male_sandals.visible = false;
			this.female_oxxo_shirt.visible = false;
			this.female_shirt.visible = false;
			this.female_top.visible = false;
			this.female_pants.visible = false;
			this.female_short.visible = false;
			this.female_skirt.visible = false;
			this.female_shoes.visible = false;
			this.female_heels.visible = false;
			this.female_sandals.visible = false;

			this.male_sandals_01.visible = true;
			this.male_shirt_01.visible = true;
			this.male_short_01.visible = true;
			this.female_pants_01.visible = true;
			this.female_sandals_01.visible = true;
			this.female_top_01.visible = true;
		}
	}

	renderAnimations(delta) {
		if (this.mixer && this.mixerFemale) {
			this.mixer.update(delta);
			this.mixerFemale.update(delta);
		}
	}
}
